export const products = [
  {
    id: 1,
    name: "Green Checked Shirt",
    category: "shirts",
    price: 999,
    image: "/ProductImages/shirt1.jpg",
  },

    {
    id: 2,
    name: "Checked Red Shirt",
    category: "shirts",
    price: 999,
    image: "/ProductImages/shirt5.jpg",
  },
  {
    id: 3,
    name: "The Originals",
    category: "t-shirts",
    price: 799,
    image: "/ProductImages/tee6.jpg",
  },
  {
    id: 4,
    name: "Straight Fit Blue Jeans",
    category: "bottoms",
    price: 999,
    image: "/ProductImages/jeans4.jpg",
  },
    {
    id: 5,
    name: "Blue Baggy Jeans",
    category: "bottoms",
    price: 1299,
    image: "/ProductImages/jeans2.jpg",
  },
{
     id: 6,
    name: "Illuminati Favorite",
    category: "t-shirts",
    price: 1299,
    image: "/ProductImages/tee3.jpg",
  },
  {
     id: 7,
    name: "Florals Lover",
    category: "t-shirts",
    price: 1299,
    image: "/ProductImages/tee4.jpg",
  },
    {
     id: 8,
    name: "Gray Checked Shirt",
    category: "shirts",
    price: 899,
    image: "/ProductImages/shirt18.jpg",
  },
    {
     id: 9,
    name: "Green Emroided Shirt",
    category: "shirts",
    price: 1299,
    image: "/ProductImages/shirt13.jpg",
  },

     {
     id: 10,
    name: "Blue Checked Shirt",
    category: "shirts",
    price: 1099,
    image: "/ProductImages/shirt16.jpg",
  },

    {
     id: 11,
    name: "Hand Bracelet",
    category: "accessories",
    price: 699,
    image: "/ProductImages/acc2.jpg",
  },
    {
     id: 11,
    name: "Neck Bracelet Men",
    category: "accessories",
    price: 899,
    image: "/ProductImages/acc4.jpg",
  },

      {
     id: 11,
    name: "Pant Designer Chain",
    category: "accessories",
    price: 399,
    image: "/ProductImages/acc6.jpg",
  },
];